
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';
import { Button } from '@/components/ui/button';
import { Loader2, Shield } from 'lucide-react';

const AuthButtons: React.FC = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center space-x-1" aria-label="Loading authentication state">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm text-muted-foreground">Loading...</span>
      </div>
    );
  }

  if (user) {
    return (
      <div className="flex items-center space-x-2">
        {user.isAdmin && (
          <Button 
            variant="outline" 
            asChild 
            className="font-medium text-gray-700 hover:text-red-600 transition-colors"
            aria-label="Admin Dashboard"
          >
            <Link to="/admin">
              <Shield className="mr-1 h-4 w-4" />
              Admin
            </Link>
          </Button>
        )}
        <Button 
          asChild 
          className="bg-purple-600 hover:bg-purple-700 transition-colors"
          aria-label="Go to dashboard"
        >
          <Link to="/dashboard">Dashboard</Link>
        </Button>
      </div>
    );
  }

  return (
    <>
      <Button 
        variant="ghost" 
        asChild 
        className="font-medium text-gray-700 hover:text-purple-600 transition-colors"
        aria-label="Sign in"
      >
        <Link to="/login">Sign In</Link>
      </Button>
      <Button 
        asChild 
        className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-medium shadow-md hover:shadow-lg transition-all"
        aria-label="Sign up"
      >
        <Link to="/signup">Sign Up</Link>
      </Button>
    </>
  );
};

export default AuthButtons;
